import React from 'react';
import PropTypes from 'prop-types';

import GenericMenu from 'dpl/path_to_payment/components/GenericMenu';

import MobileFilterButtons from './MobileFilterButtons';

export default function ExposedFilterDropdown({
  isOpen,
  setIsOpen,
  toggleButton,
  children,
  title,
  totalItemCount,
  resultsType,
  setIsMenuOpen
}) {
  return (
    <div className="relative">
      {toggleButton}
      {isOpen && (
        <GenericMenu
          setIsMenuOpen={setIsOpen}
          className="ExposedFilterDropdownMenu__container mt2 z-max absolute pv6 ph4 ph6-lg left-0"
          closeOnClickOutside
        >
          <p className="mb2 fw-medium font-24 font-serif">{title}</p>
          {children}
          <MobileFilterButtons
            className="mt8"
            setIsMenuOpen={setIsMenuOpen}
            totalItemCount={totalItemCount}
            resultsType={resultsType}
          />
        </GenericMenu>
      )}
    </div>
  );
}

ExposedFilterDropdown.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  toggleButton: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  resultsType: PropTypes.string.isRequired,
  totalItemCount: PropTypes.number.isRequired,
  setIsMenuOpen: PropTypes.func.isRequired
};
